<template>
  <v-dialog v-model="dialog" persistent max-width="700px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn text medium icon v-bind="attrs" v-on="on">
        <v-icon medium color="white lighten-1"> mdi-plus-circle </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-row class="mx-0">
        <v-col cols="12" class="d-flex justify-center">
          <v-card-title>
            <span class="headline">Cadastro de Itens da Nota Fiscal</span>
          </v-card-title>
        </v-col>
      </v-row>
      <v-card-text>
        <v-form ref="new_invoice_item_form">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <v-text-field
                v-model="$v.form.description.$model"
                label="Descrição*"
                color="red lighten-1"
                required
                :error-messages="errors.data.description"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="11">
              <v-combobox
                v-model="$v.form.selected_categories.$model"
                :items="acquisition_categories"
                item-value="id"
                item-text="category_name"
                chips
                clearable
                label="Selecione as categorias relacionadas ao item adquirido."
                multiple
                prepend-icon="mdi-filter-variant"
                solo
                elevation="0"
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(item)"
                  >
                    <strong>{{ item.category_name }}</strong>
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="1" sm="1" md="1" lg="1" xl="1">
              <NewAcquisitionCategory />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <v-textarea
                v-model="$v.form.detailed_description.$model"
                color="red lighten-1"
                :error-messages="errors.data.detailed_description"
              >
                <template v-slot:label>
                  <div>Descrição Detalhada*</div>
                </template>
              </v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
              <v-text-field
                v-model="$v.form.amount.$model"
                v-mask="'#######'"
                label="Quantidade Adquirida*"
                color="red lighten-1"
                required
                :error-messages="errors.data.amount"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6">
              <v-text-field
                v-model="$v.form.unit_price.$model"
                v-money="money"
                label="Preço Unitario*"
                color="red lighten-1"
                required
                :error-messages="errors.data.unit_price"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="black" @click="close()" text> Fechar </v-btn>
        <v-btn color="black" @click="storeInvoiceItem()" text> Salvar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import { VMoney } from 'v-money'
import NewAcquisitionCategory from '@/views/home/components/NewAcquisitionCategory'

export default {
  name: 'NewInvoiceItemForm',
  directives: { mask, money: VMoney },
  props: { invoiceId: Number },
  components: { NewAcquisitionCategory },

  data: () => ({
    dialog: false,
    categories_names: [],
    money: {
      decimal: '.',
      thousands: ' ',
      prefix: 'R$ ',
      precision: 2,
      masked: false,
    },

    form: {
      description: '',
      detailed_description: '',
      unit_price: '',
      selected_categories: [],
      amount: '',
    },
    errors: {
      messages: {
        required: 'O campo e obrigatorio',
        maxLength: 'A descrição deve ter menos de 50 caracteres',
      },
      data: {
        description: [],
        unit_price: [],
        detailed_description: [],
        selected_categories: [],
        amount: [],
      },
    },
  }),
  validations: {
    form: {
      description: { required },
      detailed_description: { required },
      selected_categories: {},
      unit_price: { required },
      amount: { required },
    },
  },
  computed: {
    ...mapState('acquisitions', ['acquisition_categories']),
  },
  methods: {
    ...mapActions('ui', ['ActionSetLoading']),
    ...mapActions('acquisitions', ['ActionStoreInvoiceItem']),

    async storeInvoiceItem() {
      this.ActionSetLoading(true)

      try {
        this.$v.$touch()
        Object.keys(this.errors.data).forEach((key) => {
          this.errorMensage(key)
        })
        if (!this.$v.$invalid) {
          let treated_form = new FormData()
          for (let index = 0; index < this.form.selected_categories.length; index++) {
            treated_form.append(
              'selected_categories[' + index + ']',
              this.form.selected_categories[index].id
            )
          }
          treated_form.append('description', this.form.description)
          treated_form.append('detailed_description', this.form.detailed_description)
          treated_form.append('unit_price', this.form.unit_price)
          treated_form.append('amount', this.form.amount)
          treated_form.append('invoice_id', this.invoiceId)

          await this.ActionStoreInvoiceItem(treated_form)
          this.$swal({
            icon: 'success',
            title: 'Cadastrado',
            text: 'Item registrado com sucesso',
          })
          this.close()
        }
      } catch (error) {
        if (error.body) {
          if (error.status != 422) {
            this.$swal({
              icon: 'error',
              title: 'Erro',
              text: error.body.message,
            })
          }
          if (error.body.errors) {
            Object.keys(error.body.errors).map((key) => {
              this.errors.data[key] = error.body.errors[key]
            })
          }
        }
      }
      this.ActionSetLoading(false)
    },

    remove(item) {
      this.chips.splice(this.chips.indexOf(item), 1)
      this.chips = [...this.chips]
    },

    close() {
      // this.form.unit_price = ''

      this.$refs.new_invoice_item_form.reset()
      this.$refs.new_invoice_item_form.resetValidation()
      this.dialog = false

      console.log(this.form.unit_price)
      console.log(this.money)
    },

    errorMensage(key) {
      const errors = []
      if (key == 'id') return
      if (!this.$v.form[key].$dirty) return errors

      if (this.$v.form[key].required !== undefined)
        !this.$v.form[key].required && errors.push(this.errors.messages.required)

      if (this.$v.form[key].minLength !== undefined)
        !this.$v.form[key].minLength &&
          errors.push(this.errors.messages.minLength(this.$v.form[key].$params.minLength.min))

      if (this.$v.form[key].maxLength !== undefined)
        !this.$v.form[key].maxLength &&
          errors.push(this.errors.messages.maxLength(this.$v.form[key].$params.maxLength.max))

      if (this.$v.form[key].email !== undefined)
        !this.$v.form[key].email && errors.push(this.errors.messages.email)

      this.errors.data[key] = errors
    },
  },
}
</script>